import { Auth0ContextInterface } from '@auth0/auth0-react';

let client: Auth0ContextInterface;

export const getAuthClient = (): Auth0ContextInterface => client;
export const setAuthClient = (newClient: Auth0ContextInterface): void => {
  client = newClient;
};
